import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'initialReference', label: 'Référence commande initiale' },
  { id: 'createdDate', label: 'Date de création' },
  { id: 'sender', label: 'Expéditeur' },
  { id: 'status', label: 'État de la commande' },
  { id: 'sendType', label: "Type d'envoi" },
  { id: 'trackingNumber', label: 'Numéro de suivi' },
  { id: 'type', label: 'Type' }
];

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  }
});

const EnhancedTableHead = () => (
  <TableHead className={styles.root}>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left">
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
